import { render, staticRenderFns } from "./SopBoardTab.vue?vue&type=template&id=3605e75f&"
import script from "./SopBoardTab.vue?vue&type=script&lang=js&"
export * from "./SopBoardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3605e75f')) {
      api.createRecord('3605e75f', component.options)
    } else {
      api.reload('3605e75f', component.options)
    }
    module.hot.accept("./SopBoardTab.vue?vue&type=template&id=3605e75f&", function () {
      api.rerender('3605e75f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/SopBoardTab.vue"
export default component.exports